<textarea
    id=hiddenClipboardBox
    style="position:fixed; left:-10000px; top: -500px"
    tabindex=-1
    role=none
    aria-hidden=true
    translate-attr="{'aria-label': 'SESSION_PANEL_LABEL'}">
</textarea>
